<template>
	<div v-if="$page.props.adminRole=='Volunteer'">
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link submenu"
				:class="{
					active: $page.component === 'Admin/Transactions/Expired',
				}"
				:href="route('admin.transactions.expired')"
			>
				<span class="nav-main-link-name">Expired</span>
			</inertia-link>
		</li>
	</div>
	<div v-else>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Home' }"
				:href="route('admin.home')"
			>
				<i class="nav-main-link-icon fa fa-home"></i>
				<span class="nav-main-link-name">Dashboard</span>
			</inertia-link>
		</li>
		<li class="nav-main-heading">Manage</li>
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/UserManagement') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-users-cog"></i>
				<span class="nav-main-link-name">Members</span>
			</a>
			<ul class="nav-main-submenu">
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/UserManagement/Members',
						}"
						:href="route('admin.user-management.members.index')"
					>
						<span class="nav-main-link-name">Manage</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/UserManagement/EpayPayment',
						}"
						:href="route('admin.user-management.epay-payment')"
					>
						<span class="nav-main-link-name">ePay</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Monitoring' }"
				:href="route('admin.monitoring.index')"
			>
				<i class="nav-main-link-icon fa fa-desktop"></i>
				<span class="nav-main-link-name">Monitoring</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Coupons' }"
				href="/admin/coupons"
			>
				<i class="nav-main-link-icon fa fa-exclamation-triangle"></i>
				<span class="nav-main-link-name">Coupons</span>
			</inertia-link>
		</li>
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/Transactions') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-newspaper"></i>
				<span class="nav-main-link-name">Transactions</span>
			</a>
			<ul class="nav-main-submenu">
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/Transactions/Completed',
						}"
						:href="route('admin.transactions.completed')"
					>
						<span class="nav-main-link-name">Completed</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/Transactions/Pending',
						}"
						:href="route('admin.transactions.pending')"
					>
						<span class="nav-main-link-name">Pending</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link"
						:class="{ active: $page.component === 'Admin/Transactions/AbandonedTracker' }"
						:href="route('admin.transactions.abandoned-tracker')"
					>
						<!-- <i class="nav-main-link-icon fa fa-search-minus"></i> -->
						<span class="nav-main-link-name">Abandoned Tracker</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/Transactions/Failed',
						}"
						:href="route('admin.transactions.failed')"
					>
						<span class="nav-main-link-name">Failed</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/Transactions/Expired',
						}"
						:href="route('admin.transactions.expired')"
					>
						<span class="nav-main-link-name">Expired</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/DeliveryFreebookManage' }"
				href="/admin/delivery/freebooks"
			>
				<i class="nav-main-link-icon fa fa-book"></i>
				<span class="nav-main-link-name">Delivery Freebooks</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/SamTable' }"
				href="/admin/sam-table"
			>
				<i class="nav-main-link-icon fa fa-chart-pie"></i>
				<span class="nav-main-link-name">SAM Table</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/VideoLibrary' }"
				href="/admin/video-library"
			>
				<i class="nav-main-link-icon fa fa-video"></i>
				<span class="nav-main-link-name">Videos Library</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/VideoLiveSchedule' }"
				href="/admin/video-live-schedule"
			>
				<i class="nav-main-link-icon fa fa-photo-video"></i>
				<span class="nav-main-link-name">Video Live Schedules</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Events' }"
				href="/admin/events"
			>
				<i class="nav-main-link-icon fa fa-calendar-alt"></i>
				<span class="nav-main-link-name">Events</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/UpcomingEvents' }"
				href="/admin/upcoming-events"
			>
				<i class="nav-main-link-icon fa fa-calendar"></i>
				<span class="nav-main-link-name">Upcoming Events</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/InvestorZoom/InvestorZoomEvents' }"
				href="/admin/investor-zoom/events"
			>
				<i class="nav-main-link-icon fa fa-video"></i>
				<span class="nav-main-link-name">Investor Zoom Events</span>
			</inertia-link>
		</li>
		<li v-if="['ian','thibz'].includes($page.props.user.fname)" class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/TktAttendeesCheckin' }"
				href="/admin/tkt-attendees/checkin"
			>
				<i class="nav-main-link-icon fa fa-check-circle"></i>
				<span class="nav-main-link-name">Attendees Checkin</span>
			</inertia-link>
		</li>
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/AffiliateProgram') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-sitemap"></i>
				<span class="nav-main-link-name">Affiliate Program</span>
			</a>
			<ul class="nav-main-submenu">
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/AffiliateProgram/AffiliateNameApproval',
						}"
						:href="route('admin.affiliate-program.affiliate-name-approval')"
					>
						<span class="nav-main-link-name">Affiliate Name</span>
					</inertia-link>
				</li>
				<li v-if="['thibz','ian','cc-ivor'].includes($page.props.user.fname)" class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/AffiliateProgram/PayoutRequest',
						}"
						:href="route('admin.affiliate-program.payout-request')"
					>
						<span class="nav-main-link-name">Payout Request</span>
					</inertia-link>
				</li>
				<li v-if="['thibz','ian','cc-ivor'].includes($page.props.user.fname)" class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/AffiliateProgram/PayoutReport',
						}"
						:href="route('admin.affiliate-program.payout-report')"
					>
						<span class="nav-main-link-name">Payout Report</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/AffiliateProgram/AffiliateLink',
						}"
						:href="route('admin.affiliate-program.affiliate-link')"
					>
						<span class="nav-main-link-name">Affiliate Link</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/AffiliateProgram/EmailSwipes',
						}"
						:href="route('admin.affiliate-program.email-swipes')"
					>
						<span class="nav-main-link-name">Email Swipes</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/AffiliateProgram/MarketingVideos',
						}"
						:href="route('admin.affiliate-program.marketing-videos')"
					>
						<span class="nav-main-link-name">Marketing Videos</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/AffiliateProgram/MarketingImages',
						}"
						:href="route('admin.affiliate-program.marketing-images')"
					>
						<span class="nav-main-link-name">Marketing Images</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/Investments') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-chart-line"></i>
				<span class="nav-main-link-name">Investments</span>
			</a>
			<ul class="nav-main-submenu">
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/Investments/InformationApproval',
						}"
						:href="route('admin.investments.information-approval')"
					>
						<span class="nav-main-link-name">Information Approval</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/Investments/Transactions',
						}"
						:href="route('admin.investments.transactions')"
					>
						<span class="nav-main-link-name">Transactions</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/Investments/ApprovalRequest',
						}"
						:href="route('admin.investments.approval-request')"
					>
						<span class="nav-main-link-name">Approval Request</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/GroupInsurance' }"
				href="/admin/group-insurance"
			>
				<i class="nav-main-link-icon fa fa-user-circle"></i>
				<span class="nav-main-link-name">Group Insurance</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/FbGroupManagement/index' }"
				href="/admin/fb-group-management"
			>
				<i class="nav-main-link-icon fab fa-facebook"></i>
				<span class="nav-main-link-name">Facebook Group</span>
			</inertia-link>
		</li>
		<li class="nav-main-heading">Content</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Announcements' }"
				href="/admin/announcements"
			>
				<i class="nav-main-link-icon fa fa-bullhorn"></i>
				<span class="nav-main-link-name">Announcements</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/StockUpdates' }"
				href="/admin/stock-updates"
			>
				<i class="nav-main-link-icon fa fa-flag"></i>
				<span class="nav-main-link-name">Stock Updates</span>
			</inertia-link>
		</li>
		<!-- <li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/BCC' }"
				href="/admin/bcc-content"
			>
				<i class="nav-main-link-icon fa fa-edit"></i>
				<span class="nav-main-link-name">BCC Content</span>
			</inertia-link>
		</li> -->
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/TRCCouples') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="fa fa-male ms-1"></i>
				<i class="fa fa-female me-2"></i>
				<span class="nav-main-link-name">TRC Couples</span>
			</a>
			<ul class="nav-main-submenu">
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/TRCCouples/TRCCouplesContent',
						}"
						href="/admin/trc-couples/contents"
					>
						<span class="nav-main-link-name">Contents</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/TRCCouples/TRCCouplesBlogs',
						}"
						href="/admin/trc-couples/blogs"
					>
						<span class="nav-main-link-name">Blogs</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/TRCAiCircle') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-user-secret"></i>
				<span class="nav-main-link-name">TRC AI Circle</span>
			</a>
			<ul class="nav-main-submenu">
					<li class="nav-main-item">
						<inertia-link
							class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/TRCAiCircle/TRCAiCircleBlogs',
						}"
							href="/admin/trc-ai-circle/latest-updates"
						>
							<span class="nav-main-link-name">Latest Updates</span>
						</inertia-link>
					</li>
			</ul>
		</li>
		<li
			class="nav-main-item"
			:class="{ open: $page.component.startsWith('Admin/SiteManagement') }"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-cogs"></i>
				<span class="nav-main-link-name">Site Management</span>
			</a>
			<ul class="nav-main-submenu">
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/SiteManagement/SidebarControl',
						}"
						href="/admin/site-management/sidebar-control"
					>
						<span class="nav-main-link-name">Sidebar Control</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active: $page.component === 'Admin/SiteManagement/HomeContent',
						}"
						href="/admin/site-management/stock-alert"
					>
						<span class="nav-main-link-name">Stock Alert</span>
					</inertia-link>
				</li>
				<li class="nav-main-item">
					<inertia-link
						class="nav-main-link submenu"
						:class="{
							active:
								$page.component === 'Admin/SiteManagement/UserMaterials/Index',
						}"
						href="/admin/site-management/user-materials"
					>
						<span class="nav-main-link-name">User Materials</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/SmsMessages' }"
				href="/admin/sms-messages"
			>
				<i class="nav-main-link-icon fa fa-comments"></i>
				<span class="nav-main-link-name">SMS Messages</span>
			</inertia-link>
		</li>
		<li class="nav-main-heading">Reports</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Reports/SmsMobileNumber' }"
				href="/admin/reports/sms-number"
			>
				<i class="nav-main-link-icon fa fa-mobile"></i>
				<span class="nav-main-link-name">SMS Mobile Number</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Reports/MembersSurveyReport' }"
				href="/admin/reports/members-survey"
			>
				<i class="nav-main-link-icon fa fa-box-open"></i>
				<span class="nav-main-link-name">Members Survey</span>
			</inertia-link>
		</li>
		<li class="nav-main-heading">Settings</li>
		<li v-if="['SuperAdmin','ComHub'].includes($page.props.adminRole)" class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Administrator' }"
				:href="route('admin.administrator')"
			>
				<i class="nav-main-link-icon fa fa-user-lock"></i>
				<span class="nav-main-link-name">Administrator</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/Administrators' }"
				href="/admin"
			>
				<i class="nav-main-link-icon fa fa-chalkboard-teacher"></i>
				<span class="nav-main-link-name">Coaching</span>
			</inertia-link>
		</li>
		<li class="nav-main-item">
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i class="nav-main-link-icon fa fa-mail-bulk"></i>
				<span class="nav-main-link-name">Email Tools</span>
			</a>
			<ul class="nav-main-submenu">
				<!-- <li class="nav-main-item">
					<a class="nav-main-link submenu" :href="route('admin.email-tools-resubscribe-gr')" target="_blank">
						<span class="nav-main-link-name">Re-Subscribe to GR</span>
					</a>
				</li> -->
			</ul>
		</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Admin/UserManagement/LoginTracker' }"
				href="/admin/user-management/login-tracker"
			>
				<i class="nav-main-link-icon fa fa-user"></i>
				<span class="nav-main-link-name">Login Tracker</span>
			</inertia-link>
		</li>
	</div>
</template>

<script>
export default {
	props: {
		user: Object,
	},
}
</script>
